import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import usertest from '../../assets/images/usertest.png';

import './TestimonialSlider.css';

const TestimonialSlider = () => {
  const { t } = useLanguage();
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonialItems = t('testimonials.items', { returnObjects: true }) || [];

  const testimonials = testimonialItems.map((item, index) => ({
    id: index + 1,
    ...item,
    image: usertest
  }));

  // Auto-rotate testimonials with infinite loop
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  const goToPrev = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToNext = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const goToDot = (index) => {
    setCurrentTestimonial(index);
  };

  const renderStars = (rating) => {
    return Array(5).fill(0).map((_, i) => (
      <span key={i} className={i < rating ? 'star filled' : 'star'}>★</span>
    ));
  };

  const getTestimonialIndex = (offset) => {
    return (currentTestimonial + offset + testimonials.length) % testimonials.length;
  };

  return (
    <section className="testimonial-section">
      <h2 className="testimonial-heading">{t('testimonials.title')}</h2>
      <div className="testimonial-container">
        <button className="testimonial-arrow prev" onClick={goToPrev}>
          <span>❮</span>
        </button>

        <div className="testimonials-wrapper">
          <div className="testimonials-carousel">
            {/* Left Card */}
            <div className="testimonial-card left">
              {(() => {
                const testimonial = testimonials[getTestimonialIndex(-1)];
                return (
                  <>

                    <div className="quote-mark">❝</div>
                    <p className="testimonial-text">{testimonial.content}</p>
                    <div className="testimonial-profile">
                      <img src={testimonial.image} alt={testimonial.name} className="profile-image" />
                    </div>
                    <div className="testimonial-rating">
                      {renderStars(testimonial.rating)}
                    </div>
                    <h4 className="testimonial-name">{testimonial.name}</h4>
                    <p className="testimonial-role">{testimonial.role}</p>
                  </>
                );
              })()}
            </div>

            {/* Center Card */}
            <div className="testimonial-card center">
              {(() => {
                const testimonial = testimonials[currentTestimonial];
                return (
                  <>
                    <div className="quote-mark">
                      <span className="blue">❝</span>
                    </div>
                    <p className="testimonial-text">{testimonial.content}</p>
                    <div className="testimonial-profile">
                      <img src={testimonial.image} alt={testimonial.name} className="profile-image" />
                    </div>
                    <div className="testimonial-rating">
                      {renderStars(testimonial.rating)}
                    </div>
                    <h4 className="testimonial-name">{testimonial.name}</h4>
                    <p className="testimonial-role">{testimonial.role}</p>
                  </>
                );
              })()}
            </div>

            {/* Right Card */}
            <div className="testimonial-card right">
              {(() => {
                const testimonial = testimonials[getTestimonialIndex(1)];
                return (
                  <>
                    <div className="quote-mark">❝</div>
                    <p className="testimonial-text">{testimonial.content}</p>
                    <div className="testimonial-profile">
                      <img src={testimonial.image} alt={testimonial.name} className="profile-image" />
                    </div>
                    <div className="testimonial-rating">
                      {renderStars(testimonial.rating)}
                    </div>
                    <h4 className="testimonial-name">{testimonial.name}</h4>
                    <p className="testimonial-role">{testimonial.role}</p>
                  </>
                );
              })()}
            </div>
          </div>
        </div>

        <button className="testimonial-arrow next" onClick={goToNext}>
          <span>❯</span>
        </button>
      </div>

      <div className="testimonial-dots">
        {testimonials.map((_, index) => (
          <button
            key={index}
            className={`dot ${currentTestimonial === index ? 'active' : ''}`}
            onClick={() => goToDot(index)}
          />
        ))}
      </div>
    </section>
  );
};

export default TestimonialSlider;
